<page-load-header *ngIf="!initialized"></page-load-header>

<h3>Banking & Expenses</h3>
<div *ngIf="initialized" class="">
  <ul class="nav nav-tabs nav-mobile-icons">
    <li class="nav-item"><a class="nav-link" [routerLink]="['banking']" [routerLinkActive]="'active'">Banking</a></li>
    <li class="nav-item"><a class="nav-link" [routerLink]="['expenses']" [routerLinkActive]="'active'">Conference Expenses</a></li>
  </ul>
  <div class="container-fluid bg-white tab-container pt-3">
    <router-outlet></router-outlet>
  </div>
</div>
